<template>
	<div class="sighting-edit row" v-if="sighting">
		<div class="col-md-6">
			<label>Taxon</label>
			<TaxonSelector v-model="sighting.taxon_data" />
			<ErrorField :errors="api_errors" field="taxon" />

			<label>Count</label>&nbsp;<i class="fa fa-info-circle" data-tooltip='Enter estimated or exact count or “X” for observed'></i>
			<input v-model="sighting.count" class="entry-count" type="text" />
			<ErrorField :errors="api_errors" field="count" />

			<label>ID Confidence</label>&nbsp;<i class="fa fa-info-circle" data-tooltip='Indicate how confident you are in the ID of the species reported.  Report confidence for the best seen individual.'></i>
			<div>
				<span v-for="confidence in id_confidences">
					<div class="input-radio">
						<span class="input__label">{{confidence.name}}</span>
						<input :name="'extra' +sighting.id + 'confidence'" :id="'extra' +sighting.id + 'confidence-' + confidence.id" type="radio" :value="confidence.id" v-model="sighting.observer_confidence" />
						<label :for="'extra' +sighting.id + 'confidence-' + confidence.id" style="display: inline-block!important;top:10px;"></label>
					</div>
				</span>
			</div>
			<ErrorField :errors="api_errors" field="observer_confidence" />

			<label>Life Stage</label><br />
			<span v-for="life_stage in life_stages">
				<div class="input-radio">
					<span class="input__label">{{life_stage.name}}</span>
					<input :name="'extra' +sighting.id + 'life-stage'" :id="'extra' +sighting.id + 'life-stage-' + life_stage.id" type="radio" :value="life_stage.id" v-model="sighting.life_stage" />
					<label :for="'extra' +sighting.id + 'life-stage-' + life_stage.id" style="display: inline-block!important;top:10px;"></label>
				</div>
			</span>
			<ErrorField :errors="api_errors" field="life_stage" />
		</div>
		<div class="col-md-6">
			<label>
				Institution 
				<strong v-if="sighting.specimen"> *(required for specimen records)</strong>
				<i class="fa fa-info-circle" data-tooltip='Required for specimen records. Name of institution where specimen is housed or indicate "Personal Collection"'></i></label>
			<input type="text" v-model="sighting.institution">
			<ErrorField :errors="api_errors" field="institution" />
			<label>Notes <i class="fa fa-info-circle" data-tooltip='Enter any notes desired for any record type. Please enter any anticipated disposition changes of all specimens. Please enter any ID points for difficult species.'></i></label>
			<textarea v-model="sighting.notes"></textarea>
			<ErrorField :errors="api_errors" field="notes" />
			<div class="input-checkbox">
				<input :id="'checkboxextra' +sighting.id" type="checkbox" :name="sighting.specimen" v-model="sighting.specimen" />
				<label :for="'checkboxextra' +sighting.id"></label>
			</div>
			<span>Specimen <small>(must be checked for specimen records)</small></span>
		</div>
		<div class="col-md-12">
			<br />
			<h4>Submit Photos (Please ensure all photos are tightly cropped):</h4>
			<ImageManager v-model="sighting.photos" :uniqueid="'file-upload-extra' +sighting.id"></ImageManager>
			<br />
		</div>
		<div class="col-md-12">
			<div class="request-expert">
				<div class="input-checkbox">
				<input type="checkbox" name="request_expert" v-model="sighting.request_vetting" />
				<label for="request_expert"></label>
				</div>
				<span>I request expert vetting of this record</span>
			</div>
		</div>
		<div class="col-md-8">
			<button @click="editSave()" class="btn btn-block btn-primary">Save</button>
		</div>
		<div class="col-md-2">
			<button @click="editDelete()" class="btn btn-block btn-danger">Delete</button>
		</div>
		<div class="col-md-2">
			<button @click="editCancel()" class="btn btn-block">Cancel</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'RecordEdit',
		props: ['value'],
		data: function(){
			return {
				sighting: this.value ? this.value : null,
				id_confidences:null,
				life_stages:null,
				api_errors:{},
			};
		},
		mounted: function(){
			var self = this;
			this.setupSighting();
			this.API({
				endpoint: 'life-stages',
				funcThen: function(response){
					self.life_stages = response.data.life_stages;
				},
			});
			this.API({
				endpoint: 'id-confidences',
				funcThen: function(response){
					self.id_confidences = response.data.id_confidences;
				},
			});
		},
		methods:{
			getPatchData: function(){
				var count = parseInt(this.sighting.count);
				if (isNaN(count)) {
					count = null;
				}

				var photos = [];
				if (this.sighting.photos) {
					for (var i = 0; i < this.sighting.photos.length; i++) {
						if (this.sighting.photos[i].response.sighting_photo) {
							photos.push(this.sighting.photos[i].response.sighting_photo.id);
						}
					}
				}

				return {
					taxon: this.sighting.taxon_data ? this.sighting.taxon_data.id : 0,
					count: count,
					observer_confidence: this.sighting.observer_confidence,
					life_stage: this.sighting.life_stage,
					institution: this.sighting.institution,
					notes: this.sighting.notes,
					specimen: this.sighting.specimen,
					photos: photos,
					request_vetting: this.sighting.request_vetting,
				};
			},
			editSave: function(){
				var self = this;
				this.API({
	                endpoint: 'sightings/' + self.sighting.id,
	                isPatch:true,
	                postData: self.getPatchData(),
	                funcThen: function(response){
            			self.$notify({
							text: 'Sighting Saved',
							type: 'success',
						});
	                    self.$emit('sightingSaved', self.sighting);
	                },
	                funcCatch: function(error){
	                	if (error.response) {
	                    	self.api_errors = error.response.data;
	                	}
	                	else{
	                		this.$notify({
								text: 'There was an error saving your record.',
								type: 'error',
							});
	                	}
	                },
	            });
			},
			editCancel: function(){
				this.sighting = null;
				this.$emit('cancel');
			},
			editDelete: function(){
				if (!confirm("Are you sure you want to permanently delete this record?")) {
					return;
				}
				var self = this;
				this.API({
					endpoint: 'sightings/' + self.sighting.id,
					isDelete:true,
					funcThen: function(response){
						self.$notify({
						  text: 'Sighting Deleted',
						  type: 'success',
						});
						self.$emit('sightingDeleted', self.sighting.id);
					},
					funcCatch: function(error){
						self.notifyError(error.response.data);
					},
				});
			},
			setupSighting:function(){
				if (this.sighting.type == 2) {
					this.sighting.specimen = true;
				}
				for (var i = 0; i < this.sighting.photos.length; i++) {
					var temp_photo = this.sighting.photos[i];
					this.sighting.photos[i] = {
							"id": temp_photo.id,
							"fileObject": true,
							"active": false,
							"success": true,
							"response": {
								"sighting_photo": temp_photo
							},
							"progress": "100.00",
							"thumb": temp_photo.small,
					}
				}
			}
		},
		watch: {
			value:function(val){
				this.sighting = val;
				this.setupSighting();
			},
			sighting: function () {
				this.$emit('input', this.sighting);
			},
			'sighting.taxon_data': {
				handler(newVal){
					if (!this.sighting.taxon_data) {
						this.sighting.taxon = null;
					}
					this.sighting.taxon = this.sighting.taxon_data.id;
				},
				deep: true
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/SightingEdit.vue